import React from 'react';
import './Section.css';

function EthicalCare() {
  const carePillars = [
    {
      title: 'Species-Appropriate Nutrition & Hydration',
      points: [
        'High-moisture, meat-rich diet to support obligate carnivorous digestion.',
        'Multiple fresh water sources (flowing water fountains prevent chronic kidney disease).',
        'Strict avoidance of toxic foods: onions, garlic, lilies, xylitol, and chocolate.'
      ]
    },
    {
      title: 'Environmental Enrichment & 3D Territory',
      points: [
        'Vertical climbing trees, wall shelves, and high observation perches.',
        'Sturdy scratching surfaces (sisal rope) to shed outer claw husks and scent-mark.',
        'Rotating puzzle feeders to satisfy natural predatory motor sequences.'
      ]
    },
    {
      title: 'Litter Box Gold Standard',
      points: [
        'Follow the N + 1 rule: 1 litter box per cat, plus one extra in different quiet zones.',
        'Unscented, clumping substrates are preferred due to sensitive olfactory senses.',
        'Daily scooping and bi-weekly scrubbing to prevent feline lower urinary tract disease (FLUTD).'
      ]
    },
    {
      title: 'Preventive Veterinary Protocol',
      points: [
        'Timely core vaccinations (Panleukopenia, Calicivirus, Herpesvirus, Rabies).',
        'Spay / Neuter procedures for reproductive health and endocrine balance.',
        'Annual checkups, microchipping, and dental cleanings to avoid periodontal decay.'
      ]
    }
  ];

  return (
    <section className="section-panel">
      <div className="section-header">
        <h2>Ethical Treatment & Health Management</h2>
        <p>Providing for a feline requires meeting both their primal instincts and physiological health needs.</p>
      </div>
      <div className="card-grid">
        {carePillars.map((pillar, idx) => (
          <div key={idx} className="info-card">
            <h3>{pillar.title}</h3>
            <ul className="care-list">
              {pillar.points.map((point, pIdx) => (
                <li key={pIdx}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default EthicalCare;